export default __webpack_public_path__ + "static/media/imagen03.c820c6dc.png";